import { Component, forwardRef, Injector, input, model, OnInit, viewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { ControlLabelComponent } from '../../internal/control-label/control-label.component';
import { ControlSupportingTextComponent } from '../../internal/control-supporting-text/control-supporting-text.component';
import { LayoutControlComponent } from '../../internal/layout-control/layout-control.component';
import { DxRadioGroupComponent, DxRadioGroupModule, DxTemplateModule } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/radio_group';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-radiobuttons',
  templateUrl: './radiobuttons.component.html',
  styleUrl: './radiobuttons.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadiobuttonsComponent),
      multi: true
    }
  ],
  imports: [LayoutControlComponent, ControlLabelComponent, DxRadioGroupModule, DxTemplateModule, NgTemplateOutlet, ControlSupportingTextComponent]
})
export class RadiobuttonsComponent implements OnInit, ControlValueAccessor {
  private dx = viewChild.required<DxRadioGroupComponent>('dx');
  private ngControl: NgControl = null;

  caption = input.required<string>();
  helpText = input<string>('');
  value = model<unknown>(null);
  dataSource = input.required<unknown[]>();
  valueExpr = input<string>(null);
  displayExpr = input<string>(null);
  readonly = input<boolean>(false);
  itemTemplate = input<unknown>(null);

  constructor(
      private injector: Injector
    ) { }
  
  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null);
  }

  get control(): AbstractControl {
    return this.ngControl?.control;
  }
  
  get isValid(): boolean {
    return !this.control || (this.control.invalid !== true || (this.control.pristine && this.control.untouched));
  }

  onValueChanged(e: ValueChangedEvent): void {
    if (e.value !== this.value()) {
      this.onChange(e.value);
      this.value.set(e.value);
    }
  }


  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: string): void {
    this.value.set(obj);
  }

  onChange: (value: unknown) => void = () => { };
  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.dx().disabled = isDisabled;
  }
}
